export default __webpack_public_path__ + "static/media/deck-bg.beb4206e.png";